export default __webpack_public_path__ + "static/media/step3_1.eb4e4723.jpg";